import React, { useEffect, useState } from 'react';
import VAIXService from '../../utils/VAIXService';
import {
    getEventsByVaixIds,
    sortEventsByVaixPriority,
} from '../../utils/Helper';
import Wrapper from '../../ui/Wrapper';
import Text from '../../ui/Text';
import { detectMobile } from '../../utils/UiHelper';
import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import { Arrow } from '@egjs/flicking-plugins';
import '@egjs/react-flicking/dist/flicking.css';
import ArrowMy from 'images/icons/arrow-right-slider.svg';
import EventsHighlightsItem from './EventsHighLightsItem';
import { connect } from 'react-redux';
import EventsHighlightsCompany from './EventsHighlightsCompany';
import 'css/EventsHighlights/EventsHighlights.scss';
import { trackEvents } from '../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATIONS,
    VAIX_TRACKING_TYPE,
} from '../../constants/vaix/VaixTrcakingConstants';
import { ScrollingAreaWrapper } from '../../ui/ScrollingArea/styled';
import HighlightsSkeleton from '../../components/SkeletonUI/HighlightsSkeleton/HighlightsSkeleton';

const EventsHighlights = ({ auth, campaigns }) => {
    const [events, setEvents] = React.useState([]);
    const [eventsAndPromo, setEventsAndPromo] = React.useState([]);
    const [isHiddenPrev, setIsHiddenPrev] = React.useState(true);
    const [isHiddenNext, setIsHiddenNext] = React.useState(false);
    const [areEventsFetched, setAreEventsFetched] = useState(false);
    const [panelPerView, setPanelPerView] = React.useState(2.2);
    const SliderHighlights = React.useRef(null);

    useEffect(() => {
        return () => {
            setAreEventsFetched(false);
        };
    }, []);

    useEffect(
        () => {
            if (!auth.loginPending) {
                getEvents();
            }
        },
        [auth?.user?.userId, auth.loginPending]
    );

    useEffect(
        () => {
            if (
                campaigns?.data?.length > 0 &&
                events.length > 0 &&
                !areEventsFetched
            ) {
                let filteredCamping = campaigns.data.filter(
                    (item) => item.is_highlight === '1'
                );
                setEventsAndPromo([...filteredCamping, ...events]);
                setAreEventsFetched(true);
            }
        },
        [campaigns?.data, campaigns?.fetched, events]
    );

    const getEvents = () => {
        VAIXService.getVaixHighlights(auth?.user?.userId || 0).then(
            async (res) => {
                const { data } = res;
                let sortedData = sortEventsByVaixPriority(data);

                if (sortedData && sortedData.length > 0) {
                    let events = await getEventsByVaixIds(sortedData);
                    setEvents(events);
                    if (campaigns?.data?.length > 0) {
                        let filteredCamping = campaigns.data.filter(
                            (item) => item.is_highlight === '1'
                        );
                        setEventsAndPromo([...filteredCamping, ...events]);
                        setAreEventsFetched(true);
                    }
                    trackEvents(
                        events,
                        VAIX_TRACKING_TYPE.impressions,
                        VAIX_TRACKING_LOCATIONS.highlights,
                        '/sport/',
                        auth?.user?.userId || 0
                    );
                }
            }
        );
    };

    const handleResize = (width) => {
        if (width > 933) {
            setPanelPerView(3.1);
            return 3.1;
        } else if (width < 934 && width > 800) {
            setPanelPerView(2.1);
            return 2.1;
        } else if (width < 800 && width > 600) {
            setPanelPerView(2.1);
            return 2.1;
        } else if (width < 600 && width > 400) {
            setPanelPerView(1.2);
            return 1.2;
        } else if (width < 401 && width > 300) {
            setPanelPerView(1.1);
            return 1.1;
        }
    };

    const handleOnReadyItem = (e) => {
        let _items = handleResize(
            document.getElementById('eventsHighLights').offsetWidth
        );
        //add it to handle state when amount of events === panelPerView to hide next button
        handleOnChange(e, true, _items);
    };

    const handleOnChange = (e, initial, initialItems) => {
        if (initial || e.index === 0) {
            setIsHiddenPrev(true);
        } else {
            setIsHiddenPrev(false);
        }

        if (
            initial
                ? Math.round(initialItems) === eventsAndPromo.length ||
                  eventsAndPromo.length === 1
                : Math.round(e.index + panelPerView) === eventsAndPromo.length
        ) {
            setIsHiddenNext(true);
        } else {
            setIsHiddenNext(false);
        }
    };
    const getSlides = () => {
        return eventsAndPromo.map((market, index) => {
            if (!!market.is_highlight) {
                return (
                    <div
                        style={{ marginRight: '8px' }}
                        className={'events-highlights-item-wrapper'}
                        key={`${index}_highlights`}
                    >
                        <EventsHighlightsCompany
                            companyUrl={market.seo_url}
                            companyImg={market.image}
                        />
                    </div>
                );
            } else {
                return (
                    <div
                        style={{ marginRight: '8px' }}
                        className={'events-highlights-item-wrapper'}
                        key={`${index}_highlights`}
                    >
                        <EventsHighlightsItem
                            market={market}
                            userId={auth?.user?.userId}
                            position={
                                index +
                                1 -
                                (eventsAndPromo.length - events.length)
                            }
                        />
                    </div>
                );
            }
        });
    };

    const plugins = [new Arrow()];

    if (campaigns.error) {
        return null;
    }

    return (
        <>
            {!areEventsFetched ? (
                <HighlightsSkeleton key={'highlights_skeleton'} />
            ) : (
                eventsAndPromo.length > 0 && (
                    <Wrapper
                        id={'eventsHighLights'}
                        className={'eventsHighLights'}
                        margin={'0 0 20px '}
                        padding={'0'}
                        width={'100%'}
                        boxSizing={'border-box'}
                        overflow={'hidden'}
                    >
                        <Text
                            margin={'0 0 8px'}
                            padding={detectMobile() ? '0 0 0 16px' : '0'}
                            size={detectMobile() ? '16' : '20'}
                            lh={detectMobile() ? '24' : '30'}
                            weight={'700'}
                            color={'1e1e1e'}
                        >
                            Højdepunkter
                        </Text>
                        {detectMobile() ? (
                            <ScrollingAreaWrapper>
                                {getSlides()}
                            </ScrollingAreaWrapper>
                        ) : (
                            <div className="event-highlights slider-container">
                                <Flicking
                                    align={{ camera: '0', panel: '0' }}
                                    circularFallback={'linear'}
                                    circular={false}
                                    duration={400}
                                    panelsPerView={panelPerView}
                                    moveType={['strict']}
                                    bound={true}
                                    adaptive={false}
                                    inputType={['touch', 'mouse', 'pointer']}
                                    preventClickOnDrag={true}
                                    onReady={(e) => {
                                        handleOnReadyItem(e);
                                    }}
                                    onAfterResize={(e) => {
                                        handleResize(e.width);
                                    }}
                                    onChanged={(e) => {
                                        handleOnChange(e);
                                    }}
                                    plugins={plugins}
                                    ref={SliderHighlights}
                                >
                                    {getSlides()}
                                    <ViewportSlot>
                                        <button
                                            className={`flicking-arrow flicking-arrow-prev ${isHiddenPrev &&
                                                'hidden'}`}
                                        >
                                            <img src={ArrowMy} alt="" />
                                        </button>

                                        <button
                                            className={`flicking-arrow flicking-arrow-next ${isHiddenNext &&
                                                'hidden'}`}
                                        >
                                            <img src={ArrowMy} alt="" />
                                        </button>
                                    </ViewportSlot>
                                </Flicking>
                            </div>
                        )}
                    </Wrapper>
                )
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return { campaigns: state.campaigns, auth: state.auth };
};

export default connect(
    mapStateToProps,
    null
)(EventsHighlights);
